import styled from 'styled-components';


export const FilePckerContainer = styled.div`
  margin: 0 0 0 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  > div {
    border: 2px dashed #ffffff80;
    border-radius: 4px;
    height: calc(100% - 4px);

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    text-align: center;
  }

  cursor: pointer;
`